export enum BankReconciliationLogType {
    CREATED = "created",
    COMPLETED = "completed",
}
